export default {
  SET_TIMEZONE_LIST_DATA: "settings/SET_TIMEZONE_LIST_DATA",
  SET_MY_JOB_TEMPLATE_LIST: "settings/SET_MY_JOB_TEMPLATE_LIST",
  SET_COMPANY_JOB_TEMPLATE_LIST: "settings/SET_COMPANY_JOB_TEMPLATE_LIST",
  SET_TEMPLATE_DETAIL: "settings/SET_TEMPLATE_DETAIL",
  SET_LOADING_STATE: "settings/SET_LOADING_STATE"
};
